import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));

// register service worker for offline cache (autogenerated by WorkBox)
if ('serviceWorker' in navigator) {
    window.addEventListener('load', 
      () => navigator.serviceWorker.register('/service-worker.js'));
  }